import { render, staticRenderFns } from "./CustomerEditOdontogram.vue?vue&type=template&id=4ada2bd6&scoped=true"
import script from "./CustomerEditOdontogram.vue?vue&type=script&lang=js"
export * from "./CustomerEditOdontogram.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditOdontogram.vue?vue&type=style&index=0&id=4ada2bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ada2bd6",
  null
  
)

export default component.exports